(() => {
  if (customElements.get('poleward-cart-amount')) return;

  // The server owns the amount and its final formatting. This formatter only decorates intermediate frames.
  function intermediateFormat(text) {
    const match = /\d(?:[\d.,'’\s\u00a0\u202f]*\d)?/.exec(text);
    if (!match) return null;
    const number = match[0];
    const lastSeparator = Math.max(number.lastIndexOf('.'), number.lastIndexOf(','));
    const precision = lastSeparator >= 0 && number.length - lastSeparator - 1 === 2 ? 2 : 0;
    const decimal = precision ? number[lastSeparator] : '.';
    const integer = precision ? number.slice(0, lastSeparator) : number;
    const group = /[^\d]/.exec(integer)?.[0] || '';
    const prefix = text.slice(0, match.index);
    const suffix = text.slice(match.index + number.length);
    return (minor) => {
      let [whole, fraction] = (minor / 100).toFixed(precision).split('.');
      if (group) whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, group);
      return `${prefix}${whole}${precision ? decimal + fraction : ''}${suffix}`;
    };
  }

  customElements.define('poleward-cart-amount', class extends HTMLElement {
    connectedCallback() {
      this.stop();
      this.display = this.querySelector('[data-cart-amount-display]');
      this.finalText = this.querySelector('[data-cart-amount-final]')?.textContent || '';
      this.target = Number(this.dataset.targetMinor);
      this.format = intermediateFormat(this.finalText);
      if (!this.display || !this.format || !/^\d+$/.test(this.dataset.targetMinor || '') || !Number.isSafeInteger(this.target) || this.target < 0) return;
      this.started = false;
      if (typeof IntersectionObserver === 'function') {
        this.observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) this.start();
        }, { threshold: .01 });
        this.observer.observe(this);
      } else this.start();
    }

    start() {
      if (this.started || !this.isConnected) return;
      this.started = true;
      this.observer?.disconnect();
      this.observer = null;
      if (!this.target) { this.display.textContent = this.finalText; return; }
      const began = performance.now();
      this.display.textContent = this.format(0);
      const tick = (time) => {
        if (!this.isConnected) return;
        const progress = Math.min(1, Math.max(0, (time - began) / 1400));
        this.display.textContent = progress === 1 ? this.finalText : this.format(Math.round(this.target * (1 - (1 - progress) ** 3)));
        this.frame = progress < 1 ? requestAnimationFrame(tick) : null;
      };
      this.frame = requestAnimationFrame(tick);
    }

    stop() {
      if (this.frame != null) cancelAnimationFrame(this.frame);
      this.frame = null;
      this.observer?.disconnect();
      this.observer = null;
      if (this.display && this.finalText) this.display.textContent = this.finalText;
    }

    disconnectedCallback() { this.stop(); }
  });
})();
